import React, { useEffect, useRef, useState } from 'react';
import { enumUtil } from '../../../../../../../../utils/Enum';
import isNull from '../../../../../../../../utils/NullChecking';
import { ServerRequestProtected } from '../../../../../../../../utils/ServerDataRequest';
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList';
import Loader from '../../../../../../../shared/Loader/Loader';
import { useSelector } from 'react-redux';
import FormValidator from '../../../../../../../../utils/FormValidator';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const ImportTemplate = (props) => {
    const { customTemplateData, setCustomTemplateData, saveCustomTemplateData, setSaveCustomTemplateData, handleSetDefaultItemsForValidation }= props;
    let ehrTemplateDD = useSelector(state => state.GeneralDropDownsReducer.EHRTemplate);
    const API_URL = enumUtil.controller.General;
    // const [isLoading, setIsLoading] = useState(false);
    const { isLoading, setIsLoading } = props;
    const API_URL_PatientEncounter = enumUtil.controller.PatientEncounter
    const palacementDD = [
        { value: 'Top', display: 'Top' },
        { value: 'Bottom', display: 'Bottom' }
    ]
    ///Search///
    const Search_Data_Name = {
        FormIDName: "",
        InsertPositionName: "Bottom",
    }
    const [searchParamName, setSearchParamName] = useState(Search_Data_Name)

    const Search_Data_Param = {
        FormID: "",
        InsertPosition: "Bottom",
    }
    const [is, setIs] = useState(true);
    const [importFormParam, setImportFormParam] = useState(Search_Data_Param);
    // const [isImportView, setIsImportView] = useState(true);
    const [formBody, setFormBody] = useState({
        "TableName": enumUtil.enumAPITableName.EHRTemplate, "SearchCriteria": {
            "TemplateType": "Clinical Form",
            "Search": ""
        }
        // "SearchParam": ''
    })
    
    ////////////////////////////////////////////////
    let valModal = {}
    let ValidationModal = {
        FormIDVal: '',
        InsertPositionVal: ''
    }
    const [importTemplateValidationModal, setImportTemplateValidationModal] = useState(ValidationModal)

    const ImportTemplateValidation = async () => {
        // let dateCheck = MdY_To_NewDate(saveModal.FormID)?.getTime() >= MdY_To_NewDate(data?.CheckDate).getTime();
        let ValidationModal = {
            FormIDVal: FormValidator(
                importFormParam.FormID,
                enumUtil.enumValidationType.Required,
                'Form',
            ),
            InsertPositionVal: FormValidator(
                importFormParam.InsertPosition,
                enumUtil.enumValidationType.Required,
                'Placement',
            ),
        }
        await setImportTemplateValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    
    const handleChangeForm = (e) => {
        const { value, name } = e.target;
        if (['FormID', 'InsertPosition'].includes(e.target.name)) { // Payer in Grid Linking
            setIs(false);
            setSearchParamName(prev => ({ ...prev, [`${name}Name`]: value }));
        }
    }

    const handleSelectedDataForm = (selectedData, name, type) => {
        setIs(true);
        if (!isNull(selectedData)) {
            // if (type === "server") {
            if (type === "client") {
                if (name === "FormID" && !isNull(selectedData)) {
                    setImportFormParam(prev => ({ ...prev, [name]: selectedData.value }));
                    setSearchParamName(prev => ({ ...prev, [`${name}Name`]: selectedData.display }));
                }
            // }
            // if (type === "client") {
                if (name === "InsertPosition" && !isNull(selectedData)) {
                    setImportFormParam(prev => ({ ...prev, [name]: selectedData.value }));
                    setSearchParamName(prev => ({ ...prev, [`${name}Name`]: selectedData.display }));
                }
            }
        } else {
            setImportFormParam(prev => ({ ...prev, [name]: '' }));
            setSearchParamName(prev => ({ ...prev, [`${name}Name`]: '' }));
        }
        return selectedData;
    };

    // Monotonic counter for ClientTemplateID, immune to prop/render staleness.
    // Seeded from whatever save-state already exists (e.g. templates loaded from
    // a previous session), then bumped forward whenever new/higher IDs show up
    // externally, so a fresh import never collides with an existing one.

    const generateNextClientTemplateID = (saveData) => {
        const maxId = Math.max(
            0,
            ...(saveData || []).map(item => Number(item.ClientTemplateID) || 0)
        );
        return String(maxId + 1);
    };

    const handleCustomTemplateData = (response) => {
        const IsWidget = "true"
        const allowedNotes = ['SOAP'];
        const filtered = {
            ...response,
            Data: response.Data?.map(component => ({
                ...component,
                items:
                ((props?.isCustomNote === "true") || allowedNotes.includes(props?.NoteType)) ? component?.items : component?.items?.filter(it => it.IsWidget === "false")
            }))
        };
        const insertPosition = importFormParam.InsertPosition;

        setSaveCustomTemplateData(prev => {
            const nextClientTemplateID = generateNextClientTemplateID(prev);
            const newFormItem = { ...filtered, InsertPosition: insertPosition, ClientTemplateID: nextClientTemplateID };

            setCustomTemplateData(prev => [...(prev || []), newFormItem]);

            const list = prev || [];
            const index = list.findIndex(x =>
                x.ClientTemplateID
                    ? x.ClientTemplateID === nextClientTemplateID
                    : x.PatientIntakeFormID === filtered?.PatientIntakeFormID && filtered?.PatientIntakeFormID !== "0"
            );
            if (index !== -1) {
                const updated = [...list];
                updated[index] = { ...updated[index], ...newFormItem, Deleted: 'false' };
                return updated;
            }
            return [...list, { ...newFormItem, Deleted: 'false' }];
        });

        handleSetDefaultItemsForValidation(filtered?.Data?.[0]?.items || []);

        setSearchParamName(Search_Data_Name);
        setImportFormParam(Search_Data_Param);
    };

    const LoadData = () => {
        if (!importFormParam?.FormID) return
        setIsLoading(true)
        ServerRequestProtected(API_URL_PatientEncounter + "/GetEHRData", 'post', {
            "TableName": enumUtil.enumAPITableName.EHRTEMPLATE,
            "ID": importFormParam?.FormID,
        }).then((response) => {
            setIsLoading(false);
            handleCustomTemplateData(response);
        }).catch((error) => {
            setIsLoading(false)
        })
    }
    const handleOpenImport = async() => {
        await ImportTemplateValidation()
        const formId = String(importFormParam.FormID);
        const templateExists = [
            ...(props?.mainCustomTemplateData ?? []),
            ...(customTemplateData ?? [])
        ].some(template => String(template?.EHRTemplateID) === formId);

        if(templateExists){
            NotificationHandler('This template already exists.', enumUtil.enumtoaster.error)
            return;
        }

        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            // NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
        if (!importFormParam.FormID || !importFormParam.InsertPosition) return
            LoadData();
            props?.setShowImportSection(false);
        }
    }

    return(<>
            {/* {isLoading ? <Loader /> : null} */}
            {/* {isEmpty ?
            ( */}
                <div className="d-flex align-items-center gap-2 py-2 px-1 ar_import-feild ">
                    {/* <div> */}
                    <div className={`input w-304px multipleSearch-rounded position-relative ${importTemplateValidationModal?.FormIDVal ? 'error' : ''}`}>
                        
                        <SuperSearchList
                            type="client"
                            id='FormID'
                            name='FormID'
                            searchValue={searchParamName.FormIDName}
                            data={ehrTemplateDD}
                            onChange={handleChangeForm}
                            getSelectedData={handleSelectedDataForm}
                            is={is}
                            sup_btn='sup_btn'
                            sup_inp='superSearchVisitInp'
                            // disabled={true}
                            isReadOnly={false}
                            icon={'Simple'}
                            placeholder={'Search by form name...'}
                            inputError={importTemplateValidationModal?.FormIDVal}
                        />
                        {importTemplateValidationModal?.FormIDVal}
                    </div>
                    <div className={`input multipleSearch-rounded w-175px ${importTemplateValidationModal?.InsertPositionVal ? 'error' : ''}`}>
                        <SuperSearchList
                            type="client"
                            id='InsertPosition'
                            name='InsertPosition'
                            searchValue={searchParamName.InsertPositionName}
                            data={palacementDD}
                            onChange={handleChangeForm}
                            getSelectedData={handleSelectedDataForm}
                            is={is}
                            sup_btn='sup_btn'
                            sup_inp='superSearchVisitInp'
                            // disabled={true}
                            isReadOnly={false}
                            icon={'Simple'}
                            placeholder={'Select placement'}
                            inputError={importTemplateValidationModal?.InsertPositionVal}
                        />
                        {importTemplateValidationModal?.InsertPositionVal}
                    </div>
                    <button className="btn btn-orange rounded" onClick={handleOpenImport} 
                    // disabled={(!importFormParam.FormID || !importFormParam.InsertPosition)}
                    >Apply</button>
                </div>
            {/* ) : <></>} */}
            </>
        
    )
}
export default ImportTemplate